import { StaffApi } from 'helpers';

class ActivitiesService {
  authToken: string;
  activitiesService: StaffApi;

  public constructor(authToken: string) {
    this.authToken = authToken;
    this.activitiesService = new StaffApi('activities', authToken);
  }
}

export default ActivitiesService;
